import axios from 'axios'

export default {
  data () {
    return {
      allDimensions: []
    }
  },
  methods: {
    async loadAllDimensions () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/dimensions.json?apikey=' + this.apiKey)
      } catch(e) {
        return false
      }
      let dim = response.data
      let dimensions = []
      for (let i = 0; i < dim.length; i++) {
        if (parseInt(dim[i].level) === 0) {
          let currParent = dim[i]
          let currChildren = []
          for (let j = 0; j < dim.length; j++) {
            if (dim[j].parentid === currParent.id) {
              currChildren.push(dim[j])
            }
          }
          currParent.children = currChildren
          dimensions.push(currParent)
        }
      }
      this.allDimensions = dimensions
    }
  },
  mounted () {
    this.loadAllDimensions()
  }
}